import { defineNuxtPlugin } from '#app'
import { initializeApp } from 'firebase/app'
import { getAnalytics, isSupported } from 'firebase/analytics'

export default defineNuxtPlugin(() => {
  if (!process.client) return

  const { public: cfg } = useRuntimeConfig();

  const config = {
    apiKey:             cfg.FIREBASE_API_KEY,
    authDomain:         cfg.FIREBASE_AUTH_DOMAIN,
    projectId:          cfg.FIREBASE_PROJECT_ID,
    storageBucket:      cfg.FIREBASE_STORAGE_BUCKET,
    messagingSenderId:  cfg.FIREBASE_MESSAGING_SENDER_ID,
    appId:              cfg.FIREBASE_APP_ID,
    measurementId:      cfg.FIREBASE_MEASUREMENT_ID
  }

  // Initialize the Firebase app
  const app = initializeApp(config)

  // Only load analytics if supported by the browser
  isSupported().then((supported) => {
    if (supported) {
      const analytics = getAnalytics(app)
      // If you want to force debug mode via code:
      // window.gtag('config', config.measurementId, { debug_mode: true })
    }
  })
})